var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_159_211",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_159_211",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEf0lEQVR4nO2cW6hVRRjHp3O8lpp29SkvXewGRmG9+GKYD8IxJUQlsCCpx3oLVMKgi5RB1lMFCj0dDXrIREUkFd/SB1FDjcQuYmRRJ7t3Or8Y9myS3b7MrLnvNb/Xvdea7/vWmm++mf+sEaJQKBQKhUKhUCgUCnkDTANWAzuAS8AFYDMwIbZt2QPcCKwDdgN/0J7Nse3MEuAW4GlgF/AXvbkY2+ZsAO4GNgBHMedSbPuTBrgH2AScwo7h2L4kBTAILAS2Al/jjlWi7gCTgMUquBdxjxwgp4k6AlwNDAHvAyP45WNRJ4DrgbWqUuhUhvngKVGzMuxvwjMq62zRx5XCRuBYgECO9fj9kOjTMuwzwiBTzyca/3tW5Az+yjAdZHvPAL9p/HeOyLwM+5Y4HFYzxHMa//1U5AJhy7BevANM1kwZkvUiZYhXhnXid+BJZdubBtfdJVIDmCUHDmB/pDKsE18BC5SNjxtcd0akAjBXBfeIRpkUg0PATcrW+cCvBte+UrcyzCYfj1c2Xwd8YXj9gjqVYVXz8RMt9u81vMc3wFWhyrAh9VbEKsOq8CXwQIsvWyrcZ6vvAI8H3gB+IT/2yRTR4o8UWauwyHegZZBzY0yp1IMtvsyv+MJ8D4zzHWgpr+fEZWBlGz+qDH5NtnkNsjLwB/Lhc+DeNj4MqjRSlaEQgc4ldewGZnTwQaYRmx4yKUSgJwDvknY+fgkY6GD/SsuJ007vQW4xeK3mEmJILgOPdbH5TgeLVquDBloZfj9wnjQ4K2ekXWydoXJ2nko3cANwgPj5eHoXGwekSu2inbDR/b8j4ywHGNv6eKCHfS/jhnUiBYA1hqtfNvwMrNCw6VFHq4ajzVW+JADu05SAbDgjpSYNW+Y5VGwOikTVE5sJQTekInOthg1THS/Tpql0q9nXJoeL/WM6+fiKwU8+EJekrXQDy4CfLJ0cAZYbtPkibjkqckDlyqrd+LSJAKoe7D+OA71B5ILKmR8aOviRTj6+oo07HPSedvQceJNCSj/A8xpvnHY+bnmQtjv223FW5AqwFPixSz5eVuEBfoAf4irdtgC3ASdanDoO3FrhXi/gj7BKtw+AKXLZUTk0DFxT4R5L1KzNB2GU7hDQ6PaLqzgE3N4lBbngbVF3aPSG1tTjGr9Kdya9YIfnIPtXulMHWI9//CvdKQM84nHwC6t0pwowO9C+kjBKd4rQ2IUf4gus8Ep3YoPfMOFYI+oIjTo7FH+aLGT1FYQp59JQuhOZoJwMEOg0lO6Y4H/KLZdvZ8b2MwlofGXgWkHpz2+6bfGgCTZ5ztq4fgI/Knf6SncMcL9v41hsn5IFN9twm2yM7U/SACscbdLJS+mOAfBabZXuCIPjHotAvxrbh2zA7nO2B2PbnxWYn07QX0p3SDA7b0NSlO6qAG8ZBPrhyg3VHRrf1BzUCHJRum0BbtY4O2S7dUMFIYP9UI+DsYw2Uxa6oM4s7aR0T+52bcEQ4L02gd5iep9CD4CJ6lQGOfh9B7zePLSqUCgUCoVCoVAoFAriP/4FrHVVi1V6lakAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSend);
export default __webpack_public_path__ + "static/media/ic_send.5186f4c1e26efc191d7baf7470ee6bfa.svg";
export { ForwardRef as ReactComponent };